import React from 'react';
import './Utilities.css';

const Healthcare = () => {
  return (
     <div className="service-wrapper">
      <div className="content-overlay">
        <h2>Service public</h2>
        <p>Nous fournissons aux acteurs du service public des solutions fiables en maintenance, gestion énergétique et automatisation pour garantir la continuité et l’efficacité des services essentiels.</p>
      </div>
    </div>
  );
  
};

export default Healthcare;